import React from "react";

export const Navigation = (props) => {
  const handleLinkClick = () => {
    const navbarToggler = document.querySelector(".navbar-toggler");
    const navbarCollapse = document.querySelector("#navbarNav");

    if (navbarToggler && navbarCollapse.classList.contains("show")) {
      navbarToggler.click(); // Simula el clic en el botón para cerrar el menú
    }
  };

  return (
    <nav id="menu" className="navbar navbar-expand-lg navbar-light bg-light sticky-top">
      <div className="container align-items-center justify-content-between">
        {/* Logo */}
        <a href="#top">
          <picture className="align-items-center">
            <source media="(min-width: 990px)" srcSet="img/mto.svg" />
            <source media="(min-width: 0px)" srcSet="img/mto_b.webp" />
            <img src="img/mto_b.webp" alt="Logo" className="team-img" height="50px" />
          </picture>
        </a>
        {/* Banderas */}
        <div className="d-flex align-items-center ms-auto order-last">
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a onClick={() => props.onLanguageChange("es")} className="nav-link p-0">
            <img src="img/es.webp" alt="Bandera España" width="20px" />
          </a>
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a onClick={() => props.onLanguageChange("en")} className="nav-link p-0 ms-2">
            <img src="img/en.webp" alt="Bandera Reino Unido" width="20px" />
          </a>
        </div>
        {/* Botón del menú */}
        <button
          className="navbar-toggler order-last m-2"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Menú colapsable */}
        <div className="collapse navbar-collapse order-last order-md-5" id="navbarNav">
          <ul className="navbar-nav mx-auto">
            {props.data
              ? props.data.map((item, i) => (
                <li key={i} className="nav-item">
                  <a
                    href={`#${item.toLowerCase().replace(/ /g, "_")}`}
                    className="nav-link page-scroll"
                    onClick={handleLinkClick} // Cierra el menú al hacer clic
                  >
                    {item}
                  </a>
                </li>
              ))
              : "loading"}
          </ul>
        </div>
      </div>
    </nav>
  );
};
